export const eventCategories = [
  "全部",
  "社会民生",
  "商业消费",
  "网络传谣",
  "文娱景区",
  "食品安全",
  "交通出行",
];

export const eventStatusList = ["全部", "调查中", "已通报", "已辟谣", "已结案"];

export const events = [
  {
    id: "cat-ear-mountain-price",
    title: "云溪猫耳山景区「天价餐饮」争议：市监局已介入核查",
    category: "文娱景区",
    status: "调查中",
    summary:
      "一段称「景区一份炒饭收 128 元」的短视频快速传播。文旅与市场监管部门先后回应，目前核查仍在进行，涉事档口已暂停营业配合调查。",
    cover:
      "https://readdy.ai/api/search-image?query=Calm%20mountain%20scenic%20area%20with%20wooden%20viewing%20platform%20and%20misty%20peaks%20at%20dawn%2C%20soft%20warm%20morning%20light%2C%20muted%20earth%20tones%2C%20editorial%20documentary%20photography%20style%2C%20minimal%20clean%20composition&width=1200&height=800&seq=chigua-event-scenic-01&orientation=landscape",
    tags: ["景区收费", "市场监管", "短视频热传"],
    publishedAt: "2026-09-04",
    updatedAt: "2026-09-09",
    timeline: [
      {
        time: "2026-09-04 11:20",
        actor: "网民视频",
        type: "传言",
        title: "短视频称景区一份炒饭收费 128 元",
        content:
          "一条时长 18 秒的视频在多个平台传播，画面显示一张小票与餐盘，配文称「猫耳山山顶一份蛋炒饭 128 元」。视频未标注拍摄时间，也未展示完整菜单。",
        source: "网络流传视频（非官方）",
      },
      {
        time: "2026-09-04 16:05",
        actor: "云溪猫耳山景区",
        type: "回应",
        title: "景区：涉事档口已暂停营业，配合核查",
        content:
          "景区运营方发布说明称，已第一时间联系涉事餐饮档口，暂停其营业并封存当日小票与菜单，配合市场监管部门核查价格公示情况。",
        source: "景区官方账号说明",
      },
      {
        time: "2026-09-05 09:40",
        actor: "云溪市市场监督管理局",
        type: "通报",
        title: "市监局通报：已立案核查明码标价执行情况",
        content:
          "通报显示，执法人员已对景区内 12 家餐饮档口开展价格检查，重点核查是否明码标价、是否存在价格欺诈。初步未发现「128 元蛋炒饭」，具体菜品与价格仍在比对中。",
        source: "云溪市市场监督管理局通报",
      },
      {
        time: "2026-09-07 15:10",
        actor: "云溪市文化和旅游局",
        type: "进展",
        title: "文旅局：要求景区 3 日内完成价格公示整改",
        content:
          "文旅局要求在景区餐饮区域显著位置张贴完整价目表，并公布投诉电话。整改完成后将组织复查，结果向社会公开。",
        source: "云溪市文化和旅游局公告",
      },
      {
        time: "2026-09-09 10:00",
        actor: "云溪市市场监督管理局",
        type: "进展",
        title: "核查进展：涉事档口菜单与视频菜品不一致",
        content:
          "市监局发布阶段性说明，称视频中餐盘所用器皿与涉事档口餐具不符，正进一步核实视频来源。调查结论以最终通报为准。",
        source: "云溪市市场监督管理局通报（第二期）",
      },
    ],
  },
  {
    id: "water-outage-rumor",
    title: "「云溪将停水三天」传言：自来水公司辟谣，仅局部管网检修",
    category: "网络传谣",
    status: "已辟谣",
    summary:
      "一条称「全城停水 72 小时」的消息在小区群与社交平台转发。自来水公司当日发布辟谣说明，明确仅青槐区两条支线管网分时段检修，全市供水正常。",
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20water%20supply%20pipe%20maintenance%20scene%20with%20blue%20steel%20pipes%20and%20valve%2C%20clean%20industrial%20documentary%20photography%2C%20soft%20neutral%20lighting%2C%20organized%20minimal%20composition&width=1200&height=800&seq=chigua-event-water-02&orientation=landscape",
    tags: ["停水传言", "辟谣", "民生供水"],
    publishedAt: "2026-08-28",
    updatedAt: "2026-08-29",
    timeline: [
      {
        time: "2026-08-28 07:30",
        actor: "网络传言",
        type: "传言",
        title: "群聊消息称「今晚起全城停水三天」",
        content:
          "多个小区业主群出现内容高度一致的转发消息，称因主管破裂将全城停水 72 小时，并附带一张模糊的施工照片，未注明来源与时间。",
        source: "网络群聊转发（非官方）",
      },
      {
        time: "2026-08-28 12:15",
        actor: "云溪自来水公司",
        type: "辟谣",
        title: "官方辟谣：全市供水正常，仅局部支线检修",
        content:
          "自来水公司说明，青槐区两条支线管网将分时段检修，涉及 3 个小区，检修时段为每日 22:00 至次日 5:00，已提前张贴通知。全市其他区域供水不受影响。",
        source: "云溪自来水公司官方公告",
      },
      {
        time: "2026-08-29 09:00",
        actor: "云溪自来水公司",
        type: "进展",
        title: "跟进：受影响小区已恢复常态供水",
        content:
          "公司确认支线检修已完成，涉及小区恢复正常供水，并将本次传言整理为典型案例用于日常科普。",
        source: "云溪自来水公司跟进说明",
      },
    ],
  },
  {
    id: "sugar-free-snack",
    title: "网红零食「代糖超标」说法：品牌方送检，第三方报告待公布",
    category: "食品安全",
    status: "调查中",
    summary:
      "测评视频称某款网红零食代糖含量超出标识。品牌方回应称全流程按标准生产，已委托第三方机构复检，检测报告将于近期公开。",
    cover:
      "https://readdy.ai/api/search-image?query=Neat%20studio%20table%20with%20packaged%20snack%20samples%20and%20laboratory%20testing%20tubes%2C%20bright%20clean%20product%20photography%2C%20warm%20neutral%20background%2C%20soft%20shadows%2C%20minimal%20composition&width=1200&height=800&seq=chigua-event-snack-03&orientation=landscape",
    tags: ["代糖", "送检", "成分争议"],
    publishedAt: "2026-08-30",
    updatedAt: "2026-09-08",
    timeline: [
      {
        time: "2026-08-30 20:40",
        actor: "测评视频",
        type: "传言",
        title: "测评称零食代糖含量「超标数倍」",
        content:
          "一条测评视频引用自制检测结果，称某款零食代糖含量是包装标识的数倍。视频未公开检测机构名称与完整方法。",
        source: "第三方测评视频（非官方）",
      },
      {
        time: "2026-08-31 13:20",
        actor: "甜研社（品牌方）",
        type: "声明",
        title: "品牌声明：生产与标识符合现行标准",
        content:
          "品牌方发布声明，称产品出厂检验报告与标签一致，已委托具备资质的第三方机构对同批次产品复检，并承诺公开完整报告。",
        source: "甜研社官方声明",
      },
      {
        time: "2026-09-08 17:00",
        actor: "甜研社（品牌方）",
        type: "进展",
        title: "进展：复检样本已送交，报告预计本周公布",
        content:
          "品牌方更新说明称，同批次留样已由公证人员现场提取并送交第三方机构，检测项目覆盖代糖含量与标签符合性。",
        source: "甜研社进展说明",
      },
    ],
  },
  {
    id: "school-stranger-rumor",
    title: "「校门口陌生人搭讪学生」传言：警方通报为误会，已还原经过",
    category: "网络传谣",
    status: "已结案",
    summary:
      "家长群流传「有陌生人向学生问路并拉扯书包」。警方调取监控与走访后通报，为一名路人不慎触碰书包，未发生拉扯，双方已消除误会。",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20school%20gate%20street%20in%20early%20morning%20with%20crosswalk%20and%20green%20trees%2C%20calm%20documentary%20photography%2C%20soft%20natural%20light%2C%20muted%20colours%2C%20clean%20composition&width=1200&height=800&seq=chigua-event-school-04&orientation=landscape",
    tags: ["家长群", "警方通报", "误会澄清"],
    publishedAt: "2026-08-18",
    updatedAt: "2026-08-21",
    timeline: [
      {
        time: "2026-08-18 18:30",
        actor: "家长群转发",
        type: "传言",
        title: "家长群称「校门口有人拉扯学生书包」",
        content:
          "消息称放学时段有陌生男子向学生问路并拉扯书包，提醒家长注意。消息经多次转发后细节不断被放大。",
        source: "家长群转发（非官方）",
      },
      {
        time: "2026-08-19 10:10",
        actor: "云溪市公安局青槐分局",
        type: "通报",
        title: "警方通报：调取监控未发现拉扯行为",
        content:
          "警方调取校门口及周边监控，未发现拉扯学生书包的情形。当日放学时段有一名路人问路，因距离较近被误认为异常接触。",
        source: "云溪市公安局青槐分局通报",
      },
      {
        time: "2026-08-21 09:00",
        actor: "云溪市公安局青槐分局",
        type: "进展",
        title: "结案说明：双方已见面沟通并消除误会",
        content:
          "警方组织当事学生家长与路人见面说明情况，双方均表示理解。警方同时提醒，涉及校园安全的信息以官方发布为准。",
        source: "云溪市公安局青槐分局结案说明",
      },
    ],
  },
  {
    id: "hotpot-kitchen",
    title: "连锁火锅店后厨卫生视频：企业致歉并公布整改方案",
    category: "食品安全",
    status: "已通报",
    summary:
      "一段拍摄后厨操作的视频引发关注。企业当日回应承认部分操作不规范，公布门店停业整改、全员培训与后厨直播方案，监管部门同步通报检查情况。",
    cover:
      "https://readdy.ai/api/search-image?query=Clean%20professional%20restaurant%20open%20kitchen%20with%20stainless%20steel%20counters%20and%20fresh%20vegetables%2C%20bright%20hygienic%20food%20photography%2C%20warm%20neutral%20palette%2C%20sharp%20detail%2C%20minimal%20composition&width=1200&height=800&seq=chigua-event-kitchen-05&orientation=landscape",
    tags: ["后厨卫生", "整改", "监管检查"],
    publishedAt: "2026-08-12",
    updatedAt: "2026-08-16",
    timeline: [
      {
        time: "2026-08-12 21:05",
        actor: "网络爆料视频",
        type: "传言",
        title: "视频称火锅店后厨操作不规范",
        content:
          "一段两分钟视频在某平台传播，画面显示后厨地面有积水、食材未加盖存放。视频拍摄门店并未在内容中说明。",
        source: "网络爆料视频（非官方）",
      },
      {
        time: "2026-08-13 08:30",
        actor: "沸小满火锅",
        type: "声明",
        title: "企业致歉：涉事门店停业整改",
        content:
          "企业发布致歉声明，确认视频拍摄于其江畔新区门店，涉事门店即日起停业整改，全国门店同步开展后厨自查与全员培训。",
        source: "沸小满火锅官方声明",
      },
      {
        time: "2026-08-14 15:40",
        actor: "云溪市市场监督管理局",
        type: "通报",
        title: "监管通报：下达责令改正通知书",
        content:
          "监管通报称，已依法对涉事门店下达责令改正通知书，并对其余 8 家门店开展突击检查，发现问题 5 项，均要求限期整改。",
        source: "云溪市市场监督管理局通报",
      },
      {
        time: "2026-08-16 11:00",
        actor: "沸小满火锅",
        type: "进展",
        title: "公布整改方案：后厨明档直播上线",
        content:
          "企业公布整改方案，包括后厨明档直播、食材存放标准化、门店每周自查公示等，并邀请消费者代表参与监督。",
        source: "沸小满火锅整改方案公告",
      },
    ],
  },
  {
    id: "campus-canteen-price",
    title: "高校食堂「菜品提价」争议：校方公布成本说明与调整方案",
    category: "社会民生",
    status: "已通报",
    summary:
      "学生反映部分菜品价格上调。校方回应称系原材料成本变动，已要求食堂恢复大众菜价格并增设低价套餐，同时公开成本核算说明。",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20university%20canteen%20with%20tray%20of%20simple%20affordable%20dishes%20and%20students%20dining%2C%20warm%20neutral%20lighting%2C%20clean%20documentary%20photography%20style%2C%20minimal%20composition&width=1200&height=800&seq=chigua-event-canteen-06&orientation=landscape",
    tags: ["校园食堂", "价格说明", "成本公开"],
    publishedAt: "2026-07-29",
    updatedAt: "2026-08-03",
    timeline: [
      {
        time: "2026-07-29 12:40",
        actor: "学生反馈",
        type: "传言",
        title: "学生反映食堂大众菜价格上涨",
        content:
          "有学生在校园社群发布对比图，称部分大众菜在三周内价格上调 1 至 3 元，引发讨论。",
        source: "校园社群反馈（非官方）",
      },
      {
        time: "2026-07-30 16:20",
        actor: "云溪理工学院后勤处",
        type: "回应",
        title: "校方回应：系原材料成本变动，将复核定价",
        content:
          "后勤处回应称，近期部分食材采购价格波动，个别档口调整了售价，已启动定价复核，要求明码标价并保留大众菜档口。",
        source: "云溪理工学院后勤处回应",
      },
      {
        time: "2026-08-03 10:30",
        actor: "云溪理工学院",
        type: "通报",
        title: "校方通报：恢复大众菜价格并增设低价套餐",
        content:
          "校方通报，相关大众菜价格已恢复原价，并在三个食堂增设 8 元套餐窗口，同时在食堂入口公示原材料月度采购均价。",
        source: "云溪理工学院通报",
      },
    ],
  },
  {
    id: "express-parcel",
    title: "快递驿站「擅自丢弃包裹」视频：总部介入调查并公布处理",
    category: "商业消费",
    status: "已通报",
    summary:
      "一段称驿站将滞留包裹集中丢弃的视频引发关注。快递总部介入调查，通报称系分拣误判导致的错放，已找回大部分包裹并对网点处罚。",
    cover:
      "https://readdy.ai/api/search-image?query=Organized%20parcel%20delivery%20station%20with%20shelves%20of%20cardboard%20boxes%20and%20sorting%20labels%2C%20clean%20logistics%20documentary%20photography%2C%20neutral%20warm%20lighting%2C%20minimal%20composition&width=1200&height=800&seq=chigua-event-parcel-07&orientation=landscape",
    tags: ["快递包裹", "网点处罚", "错放"],
    publishedAt: "2026-07-18",
    updatedAt: "2026-07-24",
    timeline: [
      {
        time: "2026-07-18 19:00",
        actor: "网络视频",
        type: "传言",
        title: "视频称驿站集中丢弃滞留包裹",
        content:
          "视频显示一处网点外堆放大量包裹，拍摄者称「不要的快递直接被扔了」。视频未说明包裹来源与是否为待退回件。",
        source: "网络视频（非官方）",
      },
      {
        time: "2026-07-20 14:00",
        actor: "顺捷驿站总部",
        type: "声明",
        title: "总部回应：已成立专项组核查该网点",
        content:
          "总部表示已派专项组进驻涉事网点，暂停其收派业务并逐一核对包裹去向，同步联系受影响用户。",
        source: "顺捷驿站总部声明",
      },
      {
        time: "2026-07-24 10:20",
        actor: "顺捷驿站总部",
        type: "通报",
        title: "调查结果：系分拣误判误放，已找回九成包裹",
        content:
          "通报称，堆放包裹为无面单待处理件，因分拣误判被集中存放。均已重新核验，九成以上已找回并派送，剩余部分按流程赔付。网点被暂停合作并处罚款。",
        source: "顺捷驿站总部调查通报",
      },
    ],
  },
  {
    id: "scenic-closure-rumor",
    title: "「网红景点封闭改造、预约作废」传闻：文旅局称实行分时预约",
    category: "文娱景区",
    status: "已辟谣",
    summary:
      "网传某网红景点将封闭改造半年、已预约票作废。文旅局辟谣称仅部分步道检修，实行分时预约，已预约门票全部有效。",
    cover:
      "https://readdy.ai/api/search-image?query=Scenic%20walking%20trail%20with%20wooden%20railing%20through%20green%20forest%2C%20soft%20filtered%20sunlight%2C%20calm%20nature%20documentary%20photography%2C%20muted%20earthy%20tones%2C%20clean%20composition&width=1200&height=800&seq=chigua-event-trail-08&orientation=landscape",
    tags: ["预约门票", "分时预约", "辟谣"],
    publishedAt: "2026-07-06",
    updatedAt: "2026-07-08",
    timeline: [
      {
        time: "2026-07-06 09:15",
        actor: "网络传言",
        type: "传言",
        title: "传言称景点封闭半年、预约票作废",
        content:
          "社交平台出现截图称景点将整体封闭改造半年，已预约的门票自动作废，需重新购票。截图无官方落款。",
        source: "网络截图（非官方）",
      },
      {
        time: "2026-07-06 15:50",
        actor: "云溪市文化和旅游局",
        type: "辟谣",
        title: "文旅局辟谣：仅部分步道检修，预约有效",
        content:
          "文旅局说明，景点仅对西线两段步道进行阶段性检修，实行分时预约分流，已预约门票全部有效，无需重新购票。",
        source: "云溪市文化和旅游局辟谣公告",
      },
      {
        time: "2026-07-08 11:30",
        actor: "云溪市文化和旅游局",
        type: "进展",
        title: "跟进：检修完成，运行恢复常态",
        content:
          "文旅局确认西线步道检修已完成并重新开放，分时预约继续保留以控制高峰客流。",
        source: "云溪市文化和旅游局跟进说明",
      },
    ],
  },
];

export const latestUpdates = [
  {
    time: "09-09 10:00",
    actor: "云溪市市场监督管理局",
    text: "猫耳山景区餐饮争议进入第二阶段核查，涉事档口菜单与视频菜品不一致",
    eventId: "cat-ear-mountain-price",
  },
  {
    time: "09-08 17:00",
    actor: "甜研社",
    text: "代糖争议同批次留样已送交第三方机构，检测报告预计本周公布",
    eventId: "sugar-free-snack",
  },
  {
    time: "09-07 15:10",
    actor: "云溪市文化和旅游局",
    text: "要求猫耳山景区 3 日内完成餐饮价格公示整改并公布投诉电话",
    eventId: "cat-ear-mountain-price",
  },
  {
    time: "08-29 09:00",
    actor: "云溪自来水公司",
    text: "停水传言涉及小区已完成支线检修，供水恢复常态",
    eventId: "water-outage-rumor",
  },
  {
    time: "08-21 09:00",
    actor: "云溪市公安局青槐分局",
    text: "「校门口搭讪学生」传言已结案，双方见面消除误会",
    eventId: "school-stranger-rumor",
  },
  {
    time: "08-16 11:00",
    actor: "沸小满火锅",
    text: "公布整改方案，后厨明档直播上线并邀请消费者监督",
    eventId: "hotpot-kitchen",
  },
];

export const categoryStats = [
  { name: "社会民生", count: 34, desc: "公共政策、市政服务、校园与社区事务的官方回应" },
  { name: "商业消费", count: 41, desc: "品牌声明、消费纠纷、退赔与整改的最新进展" },
  { name: "网络传谣", count: 57, desc: "已被澄清的传言与官方辟谣原文汇总" },
  { name: "文娱景区", count: 22, desc: "景区管理、演出活动、文旅服务的通报与说明" },
  { name: "食品安全", count: 28, desc: "餐饮卫生、食品成分、检测报告相关通报" },
  { name: "交通出行", count: 19, desc: "道路施工、公交地铁调整与出行类辟谣" },
];